import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./data-usage.component.html?ngResource";
import { Component } from '@angular/core';
import { DataUsageStoreService } from '../../services/data-usage-store.service';
import { ObjectUtils } from 'primeng/utils';
import { subMonths, endOfMonth, startOfMonth, eachMonthOfInterval, format, addMonths } from 'date-fns';
const ALLOWED_MONTHS = 2;
let DataUsageComponent = class DataUsageComponent {
    usageStore;
    startDate;
    endDate;
    usages;
    frozenColumns;
    scrollableColumns;
    maxDate;
    multiSortMeta = [
        { field: 'name', order: 1 }
    ];
    get start() {
        return this.startDate;
    }
    get end() {
        return this.endDate;
    }
    constructor(usageStore) {
        this.usageStore = usageStore;
    }
    ngOnInit() {
        this.frozenColumns = [
            { field: 'name', header: 'Name' },
            { field: 'type', header: 'Type' }
        ];
        this._setDefaultDates();
        this._setScrollableColumns();
        this.fetchData();
    }
    resolveFieldData = (data, field) => ObjectUtils.resolveFieldData(data, field);
    fetchData() {
        const start = this.startDate;
        const end = this.endDate;
        if (start && end) {
            this._setScrollableColumns();
            this.usageStore.loadUsageData(start, end);
        }
    }
    _setDefaultDates() {
        const end = endOfMonth(new Date());
        const start = startOfMonth(subMonths(end, ALLOWED_MONTHS));
        this.startDate = start;
        this.endDate = end;
    }
    _setScrollableColumns() {
        const start = this.startDate;
        const end = this.endDate;
        const months = eachMonthOfInterval({
            start,
            end
        });
        this.scrollableColumns = months.map((month) => {
            const formatted = format(month, 'yyyy-MM');
            return { field: `months.${formatted}`, header: formatted };
        });
    }
    dateSelected(date) {
        this.endDate = endOfMonth(addMonths(date, ALLOWED_MONTHS));
    }
    dateCleared() {
        this.endDate = null;
    }
    exportUsages() {
        this.usageStore.exportUsages(this.scrollableColumns);
    }
    static ctorParameters = () => [
        { type: DataUsageStoreService }
    ];
};
DataUsageComponent = __decorate([
    Component({
        selector: 'datausage',
        template: __NG_CLI_RESOURCE__0
    })
], DataUsageComponent);
export { DataUsageComponent };
